import React, { useEffect, useReducer } from "react";
import IconLink from "components/IconLink";
import useI18n from "i18n/useI18n";
import usePermissions from "state/permissions";
import Form from "../components/Form";
import styled from "styled-components";
import Reducer, { initialState } from './Reducer'
import { useParams } from 'react-router-dom';
import useSalesAdjustment from "state/salesAdjustment";
import FormScrollableContainer from "pages/Group/containers/FormScrollableContainer";
import { useRouter } from "providers/router";
import { isFutureDate } from "utils/date";
import { toast } from 'react-toastify';

const CONFIG = {
  position: 'bottom-left',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

const Update = () => {
  const { translate } = useI18n();
  const [data, dispatcher] = useReducer(Reducer, initialState);
  const [, saleDispatcher, utils] = useSalesAdjustment();
  const [permissions] = usePermissions();
  const { id, groupId } = useParams();
  const { route, canGoBack } = useRouter();

  useEffect(() => {
    const data = utils.findOne(+id);  
    const payload = { sale: data, movements: data.movements }
    dispatcher({ type: "init", payload })
  }, []);
  
  const onSubmit = (e) => {
      e.preventDefault();
      const pack = {
          sale: {
              id: data.sale.id,
              eventDate: data.sale.eventDate,
              name: data.sale.name,
              comment: data.sale.comment,
              saleType: data.sale.saleType,
              saleTypeName: data.sale.saleTypeName,
              groupId,
          },
          movements: data.movements,
      };

      const eventDate = data.sale.eventDate;
      const movements = data.movements;

      if (eventDate !== null && isFutureDate(new Date(`${eventDate}T23:59:59`))) {
          let foodTotal = 0;
          let drinkTotal = 0;
          let ivaTotal = 0;
          for (const movement of movements) {
              foodTotal += +movement.food;
              drinkTotal += +movement.drink;
              ivaTotal += +movement.iva;
          }

          if (foodTotal + drinkTotal + ivaTotal < 0) {
              console.error(
                  "Event date cannot be in the future if any movement has a negative value",
              );
              toast.error(
                  "Event date cannot be in the future if any movement has a negative value",
                  {
                      toastId: "futureDateError",
                      onClose: () => {},
                      ...CONFIG,
                  },
              );
              return;
          }
      }

      saleDispatcher.updateStart(pack);
  };

  return (
    <FormScrollableContainer>
      <HeaderContainer>
        <IconLink to={canGoBack() ? route.from : `/${groupId}/adjustments`}>
          {translate("Back to Sales Adjustment")}
        </IconLink>
      </HeaderContainer>
      <div style={{ height: "10px" }}></div>

      <Form
        data={data}
        dispatcher={dispatcher}
        onSubmit={onSubmit}
        title={translate("New Adjustment")}
        loading={permissions.fetching.state}
        buttonText={translate("Save Adjustment")}
        isEdit={true}
      />
    </FormScrollableContainer>
  );
};

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export default Update;
